// One normalizer for every adapter. Sources send epoch seconds, epoch ms, ISO, or
// a composite "{location}-{ISO8601}-{tz}". Three private converters had drifted —
// two passed ms through untouched, putting events ~54,000 years out, silently.

// "Now" is ~1.7e9 in seconds and ~1.7e12 in milliseconds, so anything past this is
// milliseconds; a genuine seconds value this large would be the year 33658.
const MILLISECOND_THRESHOLD = 1e12;

function fromNumber(n) {
  if (!Number.isFinite(n)) return 0;
  return n > MILLISECOND_THRESHOLD ? Math.floor(n / 1000) : Math.floor(n);
}

/**
 * Normalize any source's timestamp to epoch SECONDS.
 * @param {number|string|null|undefined} ts
 * @returns {number} Epoch seconds, or 0 when unparseable (callers skip those).
 */
export default function toEpochSeconds(ts) {
  if (typeof ts === 'number') return fromNumber(ts);
  if (ts == null) return 0;

  const s = String(ts).trim();
  if (s === '') return 0;

  // All digits: an epoch, in either unit.
  if (/^\d+$/.test(s)) return fromNumber(Number(s));

  // ISO, possibly inside a composite key — Date.parse can't read the whole thing.
  const iso = s.match(/\d{4}-\d{2}-\d{2}T[\d:.]+/);
  const parsed = Date.parse(iso ? iso[0] : s);
  return Number.isFinite(parsed) ? Math.floor(parsed / 1000) : 0;
}
